<label class="form-label" for="name">{{'lang.globals.name' |translate}}</label>
<input id="name" name="name" class="form-control" [(ngModel)]="assetCategory.name">
<div class="my-2">{{'lang.globals.parent'|translate}}</div>
<sb-comp-dropdown-select
  [dropDownDatatype]="'ASSET_CATEGORIES'"
  [singleSelectMode]="true" [showSubmit]="false"
  [inputData]="assetCategories"
  (selectedDataEmitter)="update($event, 'ASSET_CATEGORIES')" [showColumnIcon]="false"
  [msOptions]="msCategoryOptions" (msOptionsChange)="msRequest('ASSET_CATEGORIES', $event)"
  [selectedInputData]="assetCategory.parent ? [assetCategory.parent] : []">
</sb-comp-dropdown-select>

<div class="d-flex justify-content-end mt-4">
  <button *ngIf="!isInModalContext" [disabled]="!assetCategory.name" (click)="saveClick.emit(true)" class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{'lang.globals.save' |translate}}</button>
  <button *ngIf="isInModalContext" [disabled]="!assetCategory.name" (click)="modalNavigationService.result(assetCategory)"
          class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{'lang.globals.save' |translate}}</button>
</div>
